import { useState } from 'react';
import styles from './ProfilePage.module.css';

import { Header } from '../../components/Header/Header';
import { DataInput } from '../../UI/DataInput/DataInput';
import { FooterBtn } from '../../UI/FooterBtn/FooterBtn';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetUserByIdQuery } from '../../store/api/user.api';
import { useUserDataBlurHandler } from '../../hooks/useUserDataBlurHandler';

import plusIcon from '../../assets/inputPlus-icon.svg';
import emailIcon from '../../assets/email-icon.svg';
import passIcon from '../../assets/pass-icon.svg';
import historyIcon from '../../assets/history-icon.svg';
import newsIcon from '../../assets/news-icon.svg';
import tgIcon from '../../assets/tg-icon.svg';
import supportIcon from '../../assets/support-icon.svg';

export const ProfilePage = () => {
	
	const { first_name, id } = useSelector(state => state.user.user);
	const { data: user, refetch } = useGetUserByIdQuery(id);

	const [userData, setUserData] = useState({
		email: user?.email || '',
		accountEmail: user?.accountEmail || '',
		accountPassword: user?.accountPassword || '',
		role : user?.role || '',
	});

	const handleFieldChange = (fieldName, value) => {
		setUserData((prevData) => ({
			...prevData,
			[fieldName]: value,
		}));
	};

	
	const { handleBlur } = useUserDataBlurHandler({
		checkbox: true,
		userRefetch: refetch,
		setUserDataState: setUserData,
	});

	return (
		<div className={'main'}>
			<Header inProfile={true} />
			<div className={styles.title}>
				<h2>Привет, {first_name}!</h2>
				<p>Рады тебя видеть</p>
				{
					userData.role === "ADMIN" && <Link className={styles.adminBtn} to={'/admin'}>
						ADMIN
					</Link>
				}
			</div>
			<div className={styles.content}>
				<DataInput
					text={"Почта для чеков"}
					bg={'#171717'}
					img={plusIcon}
					type={'email'}
					value={userData.email}
					onChange={(value) => handleFieldChange('email', value)}
					onBlur={(value) => handleBlur('email', value)}
					wasText={userData.email ? true : false}
				/>
				<p className={styles.data_title}>Данные от аккаунта</p>
				<DataInput
					text={"Ваша почта"}
					bg={'#171717'}
					img={emailIcon}
					type={'email'}
					value={userData.accountEmail}
					onChange={(value) => handleFieldChange('accountEmail', value)}
					onBlur={(value) => handleBlur('accountEmail', value)}
					wasText={userData.accountEmail ? true : false}
				/>
				<DataInput
					text={"Пароль"}
					bg={'#171717'}
					img={passIcon}
					type={'password'}
					value={userData.accountPassword}
					onChange={(value) => handleFieldChange('accountPassword', value)}
					onBlur={(value) => handleBlur('accountPassword', value)}
					wasText={userData.accountPassword ? true : false}
				/>
			</div>
			<div className={styles.footer}>
				<div className={styles.footer_block}>
					<Link to={'/orders'}>
						<FooterBtn
							img={historyIcon}
							title={'История'}
							description={'Ваши последние заказы в сервисе'}
							width={185}
						/>
					</Link>
					<FooterBtn
						img={newsIcon}
						title={'Новости'}
						description={'Настройтие какие новости получать от бота'}
						width={153}
					/>
				</div>
				<div className={styles.footer_block}>
					<FooterBtn
						img={tgIcon}
						title={'Telegram'}
						url={'https://t.me/+_BpAyGahJSthMGIy'}
						description={'Наш канал с новостями.'}
						width={131}
					/>
					<FooterBtn
						img={supportIcon}
						title={'Support'}
						url={'https://t.me/eazysupp'}
						description={'На всякий, если у вас будут вопросы'}
						height={136}
					/>
				</div>
			</div>
		</div>
	);
};
